import { X, Check, MessageCircle, Undo2 } from 'lucide-react';

function MatchActions({ canUndo, onLike, onPass, onUndo }) {
  return (
    <div className="absolute bottom-0 left-0 right-0 flex items-center justify-between px-[30px] py-3">
      <div className="flex items-center gap-2">
        <button
          className="flex h-16 w-16 items-center justify-center rounded-full bg-baby-pink/50 text-destructive shadow blur-window"
          onClick={onPass}
        >
          <X size={32} strokeWidth={2.5} />
        </button>
        <button
          className="flex h-10 w-10 items-center justify-center rounded-full bg-lilac/50 text-foreground shadow blur-window disabled:opacity-30"
          onClick={onUndo}
          disabled={!canUndo}
        >
          <Undo2 size={16} />
        </button>
      </div>
      <div className="flex items-center gap-2">
        <button className="flex h-10 w-10 items-center justify-center rounded-full bg-baby-blue/50 text-primary shadow blur-window">
          <MessageCircle size={16} />
        </button>
        <button
          className="flex h-16 w-16 items-center justify-center rounded-full bg-success/50 text-success-foreground shadow blur-window"
          onClick={onLike}
        >
          <Check size={32} strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );
}

export default MatchActions;
